"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function array(n, sample) {
    var a = [];
    for (var i = 0; i < n; i++) {
        a.push(typeof sample === 'undefined' ? i : sample);
    }
    return a;
}
exports.array = array;
function asArray(selectors) {
    return Array.isArray(selectors) ? selectors : [selectors];
}
exports.asArray = asArray;
function seq(start, step, max) {
    if (start === void 0) { start = 0; }
    if (step === void 0) { step = 1; }
    if (max === void 0) { max = 0; }
    var result = [];
    for (var i = start; i < max; i += step) {
        result.push(i);
    }
    return result;
}
exports.seq = seq;
//# sourceMappingURL=create.js.map